<div class="ne-messages">
  {#each messages as message, i}
    <Message
      choose="{event => choose(event)}"
      text={message.text.state}
      isSelected={message.isSelected.state}
      id="checkbox-{i}" />
  {/each}
</div>

<style>
  .ne-messages {
    overflow-y: scroll;
    padding: .5em;
    border-radius: .25em;
    -webkit-overflow-scrolling: touch;
  }
</style>

<script>
  import Message from './Message.html';

  export let messages;
  export let choose;
</script>
